Object.defineProperty(exports, '__esModule', { value: true });

var fetch = require('./fetch.js');
var xhr = require('./xhr.js');



exports.makeFetchTransport = fetch.makeFetchTransport;
exports.makeXHRTransport = xhr.makeXHRTransport;
//# sourceMappingURL=index.js.map
